import { apiClient } from "../apiClient";
import QueryHelpers from "../../components/helpers/QueryHelpers";

const getCategories = () => {
    return apiClient.get(`/events/categories`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

const getHashtags = () => {
    return apiClient.get(`/events/hashtags`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

const getAllEvents = (args) => {
    const params = {
        page: args.page ?? 1,
        pageSize: args.pageSize ?? 10,
        title: args.search ?? '',
        createdFrom: args.createdFrom ?? '2025-01-01',
        createdTo: args.createdTo ?? '2030-01-01',
        sort: args.sort ?? 'date_asc',
        location: args.location ?? ''
    }
    // Pobranie dzisiejszej daty w formacie YYYY-MM-DD w lokalnej strefie czasowej
    const todayFormatted = new Date().toLocaleDateString('en-CA');

    // Wymuszanie tylko przyszłych wydarzeń (od dziś)
    let dateFrom = args.dateFrom;
    if (!dateFrom || dateFrom < todayFormatted) {
        dateFrom = todayFormatted;
    }

    if (dateFrom) {
        params.dateFrom = dateFrom;
    }

    if (args.dateTo) {
        params.dateTo = args.dateTo;
    }
    // DON'T add category_ids and event_ids to params - handle separately

    let query = QueryHelpers.buildQueryString(params);

    // Add CategoryIds as multiple parameters for ASP.NET Core array binding
    if (args.category_ids) {
        const categoryIds = args.category_ids.split(',').map(id => id.trim()).filter(id => id);
        categoryIds.forEach(id => {
            query += `&CategoryIds=${encodeURIComponent(id)}`;
        });
    }

    // Add EventIds as multiple parameters for ASP.NET Core array binding
    if (args.event_ids) {
        const eventIds = args.event_ids.split(',').map(id => id.trim()).filter(id => id);
        eventIds.forEach(id => {
            query += `&EventIds=${encodeURIComponent(id)}`;
        });
    }

    if (args.hashtag_ids) {
        const hashtagIds = args.hashtag_ids.split(',').map(id => id.trim()).filter(id => id);
        hashtagIds.forEach(id => {
            query += `&HashtagIds=${encodeURIComponent(id)}`;
        });
    }

    return apiClient.get(`/events?${query}`);
}

const register = (id, fullName, email) => {
    const body = {
        eventId: id,
        fullName,
        email
    }
    return apiClient.post(`/events/${id}/participants`, body, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

const contact = (values) => {
    return apiClient.post(`/contact`, values, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

const getEvent = (id) => {
    return apiClient.get(`/events/${id}`, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

const getSimilarEvents = (eventId, categoryNames = [], hashtagNames = []) => {
    const todayFormatted = new Date().toLocaleDateString('en-CA');
    let query = QueryHelpers.buildQueryString({
        page: 1,
        pageSize: 5,
        dateFrom: todayFormatted,
        createdFrom: '2025-01-01',
        createdTo: '2030-01-01',
        sort: 'date_asc',
    });

    categoryNames.forEach(name => {
        query += `&CategoryNames=${encodeURIComponent(name)}`;
    });

    hashtagNames.forEach(name => {
        query += `&HashtagNames=${encodeURIComponent(name)}`;
    });

    return apiClient.get(`/events?${query}`);
}

const EventsService = {
    getCategories,
    getHashtags,
    getAllEvents,
    getEvent,
    getSimilarEvents,
    register,
    contact
};

export default EventsService;
